import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CustomHttp} from "../core/http-custom/http-custom.service";
import {AppConstants} from "../utils/constants";
import {catchError, map} from 'rxjs/operators';

@Component({
    selector: 'app-newsletter-agreement',
    templateUrl: './newsletter-agreement.component.html',
    styleUrls: ['./newsletter-agreement.component.scss'],
    standalone: false
})
export class NewsletterAgreementComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private http: CustomHttp
  ) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe(params => {
        let token = params['token'];
        let userLanguage = params['language'];
        this.http.get(`/apps/umng/api/user/confirm_newsletter_sub?token=${token}`).pipe(
          catchError((error) => this.route.navigateByUrl(AppConstants.error)),
          map((res: any) => {
            this.route.navigate([AppConstants.confirmationPage],
              {
              queryParams: {
                origin: AppConstants.newsletterAgreement,
                language: userLanguage
              }
            })
          })
        ).subscribe();
      })
  };

}
